<template>
  <div>
    <v-card class="mt-3" style="display: flex;  justify-content: space-between;">
      <div class="pa-3 mt-2 aulas-title">
          <div><strong>Ano:</strong> {{ ano }}</div>
          <div><strong>Turma:</strong> {{ descricaoTurma }}</div>

          <span v-if="showLabelDisciplinaOuCampoExperiencia">
            <div v-if="descricaDisciplina && tipoDeEnsino ==='I' && ano >= 2020"><strong>Campos de Experiência:</strong> {{ descricaDisciplina }}</div>
            <div v-else><strong>Disciplina:</strong> {{ descricaDisciplina }}</div>
          </span>
      </div>

       <div >
                <div style=" text-align: center;"  >
                  <v-tooltip top class="rounded-0 p-0">
                      <template v-slot:activator="{ on, attrs }">
                        <!-- <span>Efetuar Frequência</span> -->
                        <v-icon v-bind="attrs" v-on="on" size="20" >notification_important</v-icon>
                      </template>
                      <span class="text-caption white--text">Estas datas são correspondentes a data de abertura e fechamento do diário,<br> não
                        representam os períodos letivos conforme o calendário escolar.
                      </span>
                  </v-tooltip>
              </div>
            <div class="pr-3 aulas-title" >
              <div v-for="fechamento in this.CAA" :key="fechamento.cdpravadi" >
                <strong  class="capitalize">{{capitalizePeriodo(fechamento.dspravadi)}}:</strong> {{fechamento.datainicio | formatDataBR}} a
                {{fechamento.datafim | formatDataBR}} </div>
            </div>

       </div>
    </v-card>
    <div>
      <transition name="router-anim-diario" enter-active-class="animated fadeIn">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import formatDataBR from '@/plugins/filters/formatDataBR';
import funcaostring from '@/utils/string';
const PeriodoAvaliativoRepository = RepositoryFactory.get('periodoAvaliativo');

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');
const CAARepository = RepositoryFactory.get('configuracaoAnoLetivo');

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

export default {
  name: 'AulasFrequencia',
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    descricao: String,
    tipoDeEnsino: String,
    cdinstruc: [Number],
    cdserie: [String, Number],
    showLabelDisciplinaOuCampoExperiencia: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      descricaoTurma: '',
      descricaDisciplina: '',
      CAA: '',
    };
  },
  async beforeRouteEnter(to, from, next){
    if(typeof to.params.ano === 'undefined' || typeof to.params.cdturma === 'undefined'){
      return next('/diario-escolar');
    }
    // const { data } = await DiarioEscolarRepository.getTurmaDisciplina({
    //   ...dadosUser(),
    //   aaletivo: to.params.ano,
    //   cdturma: to.params.cdturma,
    //   cddiscipl: to.params.disciplina,
    //   cdinstruc: to.params.cdinstruc
    // });


    const data = {
      cdturma: to.params.cdturma,
      nmturma: to.params.nmturma,
      disciplina: to.params.disciplina,
      descricaDisciplina: to.params.descricaDisciplina,
      fechamento: null,
    };
    const dataCAA = await PeriodoAvaliativoRepository.getPeriodoFechamento({
      ...dadosUser(),
      aaletivo: to.params.ano,
      cdturma: to.params.cdturma,
      cddiscipl: to.params.disciplina,
      cdinstruc: to.params.cdinstruc,
    });
     data.fechamento = dataCAA.data.results;


     next(vm => vm.load(data));
  },
  methods: {
    load(data){
      //this.descricaoTurma = data.results.turma.nmturma;
      //if(data.results.disciplina) { this.descricaDisciplina = data.results.disciplina.dsdiscipl; }
      // this.CAA = data.results.fechamento;
      this.descricaoTurma = data.nmturma;
      this.descricaDisciplina = data.descricaDisciplina;
      this.CAA = data.fechamento;
    },
     capitalizePeriodo (s) {
    return funcaostring.capitalizePeriodo(s);
  }
  },
}
</script>

<style lang="scss">
.aulas-title{
  font-size: 16px;
}

.capitalize {
  text-transform: capitalize;
}

</style>
